module.exports = __webpack_public_path__ + "static/media/muscu-seniors.267c424d.jpg";